export default "__VITE_ASSET__Czne09g$__"